import { type MCPServerInfo } from '../../types';

const GooglePeopleServer: MCPServerInfo = {
  serverId: 'GOOGLE_PEOPLE',
  name: 'Google People',
  slug: 'google-people',
  description:
    'Official Google-hosted People API MCP Server for accessing user profiles, contacts, and directory people',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://people.googleapis.com/mcp/v1',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default GooglePeopleServer;
